import { render } from "./OliverChatPanel.vue?vue&type=template&id=616d5959&scoped=true"
import script from "./OliverChatPanel.vue?vue&type=script&lang=js"
export * from "./OliverChatPanel.vue?vue&type=script&lang=js"

import "./OliverChatPanel.vue?vue&type=style&index=0&id=616d5959&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616d5959"]])

export default __exports__